<div class="row space-between w100">
  <div class="col gap-4">
    <div class="row align-center gap-8 wrap">
      <h1>{{ currentTrackName }}</h1>
      <div class="row gap-8">
        <rr-badge tone="brand" *ngIf="industryTypeId">{{
          industryTypeId | getIndustryNameById
        }}</rr-badge>
        <rr-badge tone="success" iconStart="user" *ngIf="businessTypeId">{{
          businessTypeId | getBusinessTypeNameById
        }}</rr-badge>
        <rr-badge tone="warning" *ngIf="ideaTypeId">{{
          ideaTypeId | getIdeaTypeNameById
        }}</rr-badge>
      </div>
    </div>
    <div class="tiny">
      {{ streamDescription }}
    </div>
  </div>
  <!-- <h1 i18n>Congratulations, little Inno-Hero 🎉</h1> -->
  <!-- <div class="row gap-8">
    <rr-btn iconStart="ai" type="Secondary" [disabled]="true" i18n
      >Variante Result</rr-btn
    >
    <rr-btn
      iconStart="share"
      type="Secondary"
      [disabled]="false"
      i18n
      (click)="copyToClipboard(link)"
      >Share</rr-btn
    >
  </div> -->
</div>
<div class="shares grow-1 row gap-16 w100 align-start space-between">
  <!-- Results -->
  <div class="card" *ngFor="let option of results">
    <h4 i18n>{{ option.name | camelcase }}</h4>
    <div class="col">
      <rr-icon name="file" class="roundicon"></rr-icon>
      <div class="redbubble">PDF</div>
    </div>
    <!-- <img src="/images/pdf_icon.png" alt="" /> -->
    <!-- <img src="/images/miro_icon.png" alt="" /> -->
    <rr-btn
      type="Primary"
      class="w100"
      iconStart="expand"
      (click)="openSource(option)"
      >Show</rr-btn
    >
  </div>
  <div class="card" *ngIf="landingPageLink">
    <h4 i18n>Landing Page</h4>
    <div class="col">
      <rr-icon name="globe" class="roundicon"></rr-icon>
      <div class="redbubble">Web</div>
    </div>
    <!-- <img src="/images/pdf_icon.png" alt="" /> -->
    <!-- <img src="/images/miro_icon.png" alt="" /> -->
    <rr-btn
      type="Primary"
      class="w100"
      iconStart="expand"
      (click)="openInternLandingPage()"
      >Open</rr-btn
    >
  </div>

  <!-- @for(option of closingOptions; track option){
  <div class="card">
    <h4 i18n>{{ option.name | camelcase }}</h4>
    <img *ngIf="option.outputType == 'PDF'" src="/images/pdf_icon.png" alt="" />
    <img
      *ngIf="option.outputType == 'MIRO'"
      src="/images/miro_icon.png"
      alt=""
    />
    <rr-btn type="Primary" iconStart="download" (click)="downloadSource(option)"
      >Download</rr-btn
    >
  </div>
  } @for(option of reports; track option){
  <div class="card">
    <h4 i18n>{{ option.name | camelcase }}</h4>
    @if(option.name.indexOf('MIRO') == -1){
    <img src="/images/pdf_icon.png" alt="" />

    }@else {
    <img src="/images/miro_icon.png" alt="" />
    }
    <rr-btn type="Primary" iconStart="download" (click)="downloadSource(option)"
      >Download</rr-btn
    >
  </div>
  } -->
  <!-- <div class="linkshare grow-1 col gap-24">
    <div class="col gap-8 w100">
      <div class="row gap-8 w100">
        <div class="col gap-8">
          <label class="strong">Share Link:</label>
          <div class="link-text">{{ link }}</div>
        </div>
        <rr-icon
          name="copy"
          color="nutral"
          class="pointer"
          (click)="copyToClipboard(link)"
        ></rr-icon>
      </div>
    </div>
    <div class="row gap-16 w100 align-end">
      <rr-input
        i18n
        type="email"
        label="Email"
        [multipleAdresses]="true"
        [required]="true"
        [FormControl]="adresses"
        placeholder="Separate email addresses with a comma."
      ></rr-input>
      <rr-btn type="Secondary" (click)="sendLinkToAdresses()">Send Link</rr-btn>
    </div>
  </div> -->
</div>
<div class="nextsteps col gap-16 w100">
  <h2 i18n>Next steps ahead!</h2>
  <div class="row cardrow w100 gap-32 w100">
    <div class="card col gap-24">
      <div class="col gap-16 w100">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="presentation"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Turn Your Idea into a Website</h4>
        <!-- NO existing LP -->
        <div
          class="small"
          i18n
          *ngIf="
            (landingPageLink === '' || !landingPageLink) &&
            loadingLandingPage === false
          "
        >
          Create a website that brings you vision to life and gathers early
          feedback.
        </div>
        <!-- Loading screen is being prepared -->
        <div class="small strong" i18n *ngIf="loadingLandingPage === true">
          Loading screen pending
        </div>
        <!-- LP generated -->
        <div
          class="lplink row gap-16 space-between w100 align-center"
          *ngIf="landingPageLink !== '' && loadingLandingPage === false"
        >
          <span class="strong">Link:</span>
          <span class="ellipsis-1line">{{ landingPageLink }}</span>
          <div class="row gap-8">
            <rr-icon
              name="copy"
              class="pointer"
              color="nutral"
              (click)="copyToClipboard(landingPageLink)"
            ></rr-icon>
            <rr-icon
              name="reload"
              class="pointer"
              color="nutral"
              title="Genreate a new Link. The old one will be revoked."
              (click)="generatePageLink()"
            ></rr-icon>
          </div>
        </div>
      </div>
      @if(landingPageLink === '' && loadingLandingPage === false){
      <rr-btn
        type="Secondary"
        class="w100"
        i18n
        (btnclick)="landingPageLink === '' ? generateInternLandingPage() : null"
        >Generate Your Page
      </rr-btn>
      }@else if(loadingLandingPage === true) {
      <rr-btn type="Secondary" class="w100" i18n [disabled]="true"
        >Loading...
      </rr-btn>
      }@else{
      <rr-btn
        type="Secondary"
        class="w100"
        i18n
        [disabled]="landingPageLink === '' ? true : false"
        (btnclick)="landingPageLink === '' ? null : openInternLandingPage()"
        >Landing Page Preview</rr-btn
      >
      }
    </div>
    <!-- Landing Page Cards -->
    <!-- Step 0 - Create Landing Page -->
    <!-- <div class="card col gap-24" *ngIf="landingPageStep == 0">
      <div class="col gap-16">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="presentation"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Turn Your Idea into a Website</h4>
        <div class="small" i18n>
          Create a website that brings you vision to life and gathers early
          feedback.
        </div>
      </div>
      <rr-btn
        type="Secondary"
        class="w100"
        i18n
        (btnclick)="openEasyTwoDialog()"
        >Create Landing Page</rr-btn
      >
    </div> -->
    <!-- Step -1 - Error -->
    <!-- <div class="card col gap-24" *ngIf="landingPageStep == -1">
      <div class="col gap-16">
        <div class="row space-between w100">
          <rr-icon class="roundicon error-icon" name="close"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Something went wrong</h4>
        <div class="small" i18n>
          We're sorry, something went wrong. Please try again later.
        </div>
      </div>
      <rr-btn
        type="Secondary"
        class="w100"
        i18n
        (btnclick)="openEasyTwoDialog()"
        >Try again</rr-btn
      >
    </div> -->
    <!-- Step 1 - Starting Progress -->
    <!-- <div class="card col gap-24" *ngIf="landingPageStep == 1">
      <div class="col gap-16 w100">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="presentation"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Turn Your Idea into a Website</h4>
        <div class="icons-container">
          <img src="images/logo-icon.png" />
          <rr-icon class="roundicon arrow-icon" name="arrow-right"></rr-icon>
          <img src="images/easy2-icon.png" />
        </div>
      </div>
      <div class="state-container">
        <div class="state-wrapper w100">
          <div class="dot-loader">
            Starting Progress<span class="dot-animation"></span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Step 2 - Connecting accounts -->
    <!-- <div class="card col gap-24" *ngIf="landingPageStep == 2">
      <div class="col gap-16">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="presentation"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Turn Your Idea into a Website</h4>
        <div class="icons-container">
          <img src="images/logo-icon.png" />
          <rr-icon class="roundicon arrow-icon" name="arrow-right"></rr-icon>
          <img src="images/easy2-icon.png" />
        </div>
      </div>
      <div class="state-container">
        <div class="state-wrapper w100">
          <div class="dot-loader">
            Connecting accounts<span class="dot-animation"></span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Step 3 - Creating your landing page -->
    <!-- <div class="card col gap-24" *ngIf="landingPageStep == 3">
      <div class="col gap-16 w100">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="presentation"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Turn Your Idea into a Website</h4>
        <div class="icons-container">
          <img src="images/logo-icon.png" />
          <rr-icon class="roundicon arrow-icon" name="arrow-right"></rr-icon>
          <img src="images/easy2-icon.png" />
        </div>
      </div>
      <div class="state-container">
        <div class="state-wrapper w100">
          <div class="dot-loader">
            Creating your landing page<span class="dot-animation"></span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Step 4 - Success -->
    <!-- <div class="card col gap-24" *ngIf="landingPageStep == 4">
      <div class="col gap-16 w100">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="presentation"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Turn Your Idea into a Website</h4>
        <div class="icons-container">
          <img src="images/logo-icon.png" />
          <rr-icon class="roundicon success-icon" name="check"></rr-icon>
          <img src="images/easy2-icon.png" />
        </div>
      </div>
      <a
        *ngIf="landingPageLink"
        [href]="'https://' + landingPageLink"
        target="_blank"
        rel="noopener"
        class="w100 landingPageLink"
      >
        <rr-btn type="Secondary" class="w100" i18n>{{
          landingPageLink
        }}</rr-btn>
      </a>
    </div> -->
    <!-- Step 10 - Already created -->
    <!-- <div class="card col gap-24" *ngIf="landingPageStep == 10">
      <div class="col gap-16 w100">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="presentation"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>Turn Your Idea into a Website</h4>
        <a
          *ngIf="landingPageLink"
          [href]="'https://' + landingPageLink"
          target="_blank"
          rel="noopener"
          class="w100 landingPageLink link-container"
        >
          <div class="link-container-text">
            Link: <a>{{ landingPageLink }}</a>
          </div>
          <rr-icon name="external_link"></rr-icon>
        </a>
      </div>
      <rr-btn
        type="Secondary"
        class="w100"
        i18n
        (btnclick)="openEasyTwoDialog()"
        [disabled]="true"
        >Update Landing Page</rr-btn
      >
    </div> -->

    <div class="card col gap-24 disabled">
      <div class="col gap-16 w100">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="user-check"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>2. Validate Your Idea</h4>
        <div class="small" i18n>
          Challenge your idea with market, users and competitors.
        </div>
      </div>
      <rr-btn type="Secondary" iconEnd="arrow-right" class="w100"
        >New Validation</rr-btn
      >
      <!-- <rr-btn
        type="Secondary"
        iconEnd="arrow-right"
        class="w100"
        (click)="goToValidation.emit()"
        >New Validation</rr-btn
      > -->
    </div>
    <div class="card col gap-24 disabled">
      <div class="col gap-16 w100">
        <div class="row space-between w100">
          <rr-icon class="roundicon" name="launch"></rr-icon>
          <rr-icon name="info" class="info-icon" color="nutral"></rr-icon>
        </div>
        <h4 i18n>3. EXIST</h4>
        <div class="small" i18n>
          Check your potential to get an EXIST Support.
        </div>
      </div>
      <rr-btn type="Secondary" iconEnd="arrow-right" class="w100"
        >Go to Exists-Form</rr-btn
      >
    </div>
  </div>
</div>
<rr-spinner *ngIf="showspinner"></rr-spinner>
